export const APP_CONFIG = {
  name: "Fako",
  description: "Generate Fake Data",
  authorWebsiteUrl: "https://sandroroth.com",
};
